import React from 'react';
import { useSelector } from 'react-redux';

const Press = () => {
  const language = useSelector((state) => state.language);

  const pressReleases = [
    {
      en: {
        title: "RAQIB Announces New AI-Powered Features",
        description: "Revolutionary artificial intelligence capabilities now available for healthcare providers worldwide.",
        date: "March 16, 2026"
      },
      fr: {
        title: "RAQIB annonce de nouvelles fonctionnalités basées sur l'IA",
        description: "Les capacités révolutionnaires d'intelligence artificielle sont maintenant disponibles pour les prestataires de soins de santé du monde entier.",
        date: "16 mars 2026"
      },
      ar: {
        title: "RAQIB تعلن عن ميزات جديدة مدعومة بالذكاء الاصطناعي",
        description: "إمكانيات الذكاء الاصطناعي الثورية متاحة الآن لمقدمي الرعاية الصحية في جميع أنحاء العالم.",
        date: "16 مارس 2026"
      }
    },
    {
      en: {
        title: "RAQIB Secures Major Investment Round",
        description: "Leading healthcare technology company raises significant funding to accelerate global expansion.",
        date: "March 1, 2026"
      },
      fr: {
        title: "RAQIB assure un important cycle de financement",
        description: "L'entreprise technologique de soins de santé de premier plan lève un financement important pour accélérer l'expansion mondiale.",
        date: "1er mars 2026"
      },
      ar: {
        title: "RAQIB تأمن جولة استثمار كبيرة",
        description: "شركة تكنولوجيا الرعاية الصحية الرائدة تجمع تمويلاً كبيراً لتسريع التوسع العالمي.",
        date: "1 مارس 2026"
      }
    },
    {
      en: {
        title: "RAQIB Becomes HIPAA Certified",
        description: "Successfully completes rigorous compliance audit and attains HIPAA certification for enhanced data protection.",
        date: "February 20, 2026"
      },
      fr: {
        title: "RAQIB obtient la certification HIPAA",
        description: "Complète avec succès l'audit de conformité rigoureux et obtient la certification HIPAA pour une meilleure protection des données.",
        date: "20 février 2026"
      },
      ar: {
        title: "RAQIB تحصل على شهادة HIPAA",
        description: "أكملت بنجاح عملية التدقيق الصارمة للامتثال وحصلت على شهادة HIPAA لحماية البيانات المحسنة.",
        date: "20 فبراير 2026"
      }
    }
  ];

  const getPressData = (press) => {
    if (language === "ar") return press.ar;
    if (language === "fr") return press.fr;
    return press.en;
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "الأخبار" : language === "fr" ? "Presse" : "Press"}
        </h1>

        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-teal-600 mb-6">
            {language === "ar" ? "بيانات صحفية" : language === "fr" ? "Communiqués de presse" : "Press Releases"}
          </h2>

          <div className="space-y-6">
            {pressReleases.map((press, idx) => {
              const pressData = getPressData(press);
              return (
                <div key={idx} className="border-l-4 border-teal-500 pl-6 py-4 hover:bg-gray-50 transition-colors p-6 rounded">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-bold text-gray-900">{pressData.title}</h3>
                    <span className="text-sm text-gray-500 ml-4 whitespace-nowrap">{pressData.date}</span>
                  </div>
                  <p className="text-gray-600">{pressData.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-teal-600 mb-4">
            {language === "ar" ? "اتصل بفريق العلاقات العامة" : language === "fr" ? "Contactez notre équipe Relations Publiques" : "Contact Our Press Team"}
          </h2>
          <p className="text-gray-700 mb-4">
            {language === "ar"
              ? "للاستفسارات الإعلامية أو لطلب مقابلة، يرجى التواصل مع:"
              : language === "fr"
              ? "Pour les demandes médias ou pour demander une interview, veuillez contacter:"
              : "For media inquiries or interview requests, please contact:"}
          </p>
          <p className="text-gray-900 font-semibold">press@raqibapp.com</p>
        </div>
      </div>
    </div>
  );
};

export default Press;
